import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { loadAllUsers } from 'actions/user';
import { loadSpoofCandidates } from 'actions/admin';
import ReturnToMe from 'components/returnToMe';

export const PartnerSpoof = ({ history }) => {
    const dispatch = useDispatch();

    const { user, allUsers } = useSelector(state => state.user);
    const spoofCandidates = useSelector(state => state.admin?.spoofCandidates);

    React.useEffect(() => {
        if (user.companySettings?.prism_UI) {
            return;
        }

        // While spoofing, the list comes from the person really signed in, whoever is being spoofed;
        // otherwise a partner lists the customer's users itself.
        if (user?.spoofing) {
            dispatch(loadSpoofCandidates());
        } else if (user?.partner_Id > 0) {
            dispatch(loadAllUsers());
        }
    }, [user]);

    if (user.companySettings?.prism_UI || (!user?.partner_Id && !user?.spoofing)) {
        return null;
    }

    const users = user.spoofing ? spoofCandidates : allUsers;

    return (
        <div className="inline-block" id="spoof-bar">
            <div className="inline-block partner-bar text-center p5">
                PARTNER<span className="hidden-xs inline-block-md">&nbsp;PORTAL</span>
                {user.spoofing && <span> - SPOOFING</span>}
                <div className="inline-block partner-users">
                    <select
                        className="form-control"
                        onChange={e =>
                            history.push?.(`/spoofing?email=${encodeURIComponent(e.target[e.target.selectedIndex].value)}`)
                        }
                    >
                        <option>--select user to spoof--</option>
                        {users &&
                            users
                                .filter(u => u.licence === 'FULL' && u.active !== false && u.id !== user.id)
                                .sort((a, b) => a.full_Name.localeCompare(b.full_Name))
                                .map(u => (
                                    <option key={`user-${u.id}`} value={u.email}>
                                        {u.full_Name}
                                    </option>
                                ))}
                    </select>
                </div>
                {user.spoofing && <ReturnToMe className="btn btn-default btn-sm ml10" />}
            </div>
        </div>
    );
};

export default withRouter(PartnerSpoof);
